import apiService from '../Api'

interface IAuthDTO {
  email: string
  password: string
}

export default class AuthService {
  async auth({ email, password }: IAuthDTO) {
    return apiService.post('/auth/login', { email, password })
  }

  async authGoogle({ access_token }: { access_token: string }) {
    return apiService.post('/auth/login-with-google', { access_token })
  }
}
